import { CarrierState } from "../Model/ModuleState";
import { ECarrier } from "../Model/ECarrier";
import { Ri360AutoCalibrationState } from "../Model/Calibration";

class AutoCalibrationUtil {
  static getAvailableCarrierForAutoCalibration(
    carrierStates: CarrierState[]
  ): ECarrier[] {
    return carrierStates
      .filter((state) => state.autoCalibrationEnabled)
      .map((state) => state.carrier);
  }

  static getAvailableCarrierSortedWithUpdatedResult(
    carrierStates: CarrierState[],
    autoCalibrationResults: Ri360AutoCalibrationState[]
  ): ECarrier[] {
    let carriers = carrierStates
      .filter((state) => state.autoCalibrationEnabled)
      .map((state) => state.carrier);

    const compareCarriers = (
      carrier1: ECarrier,
      carrier2: ECarrier,
      autoCalibrationResults: Ri360AutoCalibrationState[]
    ) => {
      let result1 = autoCalibrationResults.find(
        (res) => res.carrier === carrier1 && res.updatedPositions !== null
      );

      let result2 = autoCalibrationResults.find(
        (res) => res.carrier === carrier2 && res.updatedPositions !== null
      );

      
      if (result1 !== undefined && result2 === undefined) {
        return -1;
      } else if (result1 === undefined && result2 !== undefined) {
        return 1;
      } else {
        return 0
      }
    };

    return carriers.sort((a, b) => {
      return compareCarriers(a, b, autoCalibrationResults);
    });
  }

  static getCarrierName = (carrier: ECarrier): string => {
    switch (carrier) {
      case ECarrier.FixedCarriage:
        return "Fixed Carrier";
      case ECarrier.MovingCarriage1:
        return "Moving Carrier 1";
      case ECarrier.MovingCarriage2:
        return "Moving Carrier 2";
      case ECarrier.LoadPort:
        return "Load Port";
      case ECarrier.Imager:
        return "Imager";
      case ECarrier.Unknown:
        return "Unknown";
      default:
        return "Unknown";
    }
  };

  static getCarrierImagePath = (carrier: ECarrier) : string => {
    switch (carrier) {
      case ECarrier.FixedCarriage:
        return "/images/carriers/fixed_carrier.png";
      case ECarrier.MovingCarriage1:
        return "/images/carriers/moveable_carrier_1.png";
      case ECarrier.MovingCarriage2:
        return "/images/carriers/moveable_carrier_2.png";
      case ECarrier.LoadPort:
        return "/images/carriers/loadport.png";
      
      default:
        return "";
    }
  }

  static ExpandableCarrier = [
    { display: "Moving Carrier 1", value: ECarrier.MovingCarriage1 },
    { display: "Moving Carrier 2", value: ECarrier.MovingCarriage2 },
    { display: "Fixed Carrier", value: ECarrier.FixedCarriage },
    { display: "Imager Carrier", value: ECarrier.Imager },
    { display: "Load Port Carrier", value: ECarrier.LoadPort },
  ];
  
}

export default AutoCalibrationUtil;
